// src/utils/qr.js
import { qrcanvas } from 'qrcanvas';

/**
 * QRコード発行（Object URL を返す）
 * @param {string} data   二次元コード生成データ
 * @param {number} size   解像度(px)
 * @returns {string}      window.URL.createObjectURL(blob) のURL
 */
export const QRcodeIssuance = (data, size = 256) => {
    const canvas = qrcanvas({ data, size });
    const [meta, base64] = canvas.toDataURL().split(';base64,');
    const contentType = meta.split(':')[1] || 'image/png';
    const raw = window.atob(base64);
    const u8 = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) u8[i] = raw.charCodeAt(i);
    const blobUrl = URL.createObjectURL(new Blob([u8], { type: contentType }));
    return blobUrl;
};

/** Object URL を安全に破棄 */
export function revokeObjectUrlSafe(url) {
    try { if (url && url.startsWith('blob:')) URL.revokeObjectURL(url); } catch { }
};
